/* eslint-disable jsx-a11y/label-has-associated-control */
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { shallowEqual } from 'recompose';
import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { usePrevious } from 'src/utils/ReactHooksUtil';
import { includeStamp } from 'src/utils/StampUtils';
import { cloneDeep } from 'lodash-es';
import FormikInput from 'src/components/formik/FormikInput';
import FormikDateTimePicker from 'src/components/formik/FormikDateTimePicker';
import moment from 'moment';
import { caseUpsertAction } from '../actions/CaseActions';
import {
    VehicleCoverNoteDefaultProps,
    VehicleCoverNoteDefaultSchema,
} from '../CasePropTypes';
import VehicleInsuranceQuotationComponent from './VehicleInsuranceQuotationComponent';
import FormikToggle from 'src/components/formik/FormikToggle';
import { POLICY_TYPES_LIST } from "../../user-container/UserConstants";
import FormikSelect from "src/components/formik/FormikSelect";

function Render(props) {
    const { values } = props;

    return (
        <div>
            <div className="card">
                <div className="card-body">
                    <h3>Vehicle Insurance Policy Detail</h3>

                    <div className="form-row">
                        <div className="form-group col-md-3">
                            <label>Policy Number</label>
                            <FormikInput
                                name="cn_number"
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Self Policy Number</label>
                            <div
                                className="form-control"
                                readOnly
                            >
                                {values?.self_cn_number || 'Auto-generated'}
                            </div>
                        </div>
                        <div className="form-group col-md-3">
                            <label>LOS No.</label>
                            <FormikInput
                                name="losNo"
                                type="text"
                                className="form-control"
                            />
                        </div>
                        <div className="form-group col-md-3">
                            <label>Insu. Agent Code</label>
                            <FormikInput
                                name="InsUAgentCode"
                                type="text"
                                className="form-control"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Policy Issue Date</label>
                            <FormikDateTimePicker
                                name="cn_date"
                                value={values?.cn_date || ''}
                                className="form-control"
                                disableClock
                                format="dd-MM-y"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Effective Date</label>
                            <FormikDateTimePicker
                                name="effective_date"
                                value={values?.effective_date || ''}
                                className="form-control"
                                disableClock
                                format="dd-MM-y"
                            />
                        </div>

                        <div className="form-group col-md-3">
                            <label>Expire Date</label>
                            <FormikDateTimePicker
                                name="expire_date"
                                value={values.expire_date || moment(values?.effective_date).add(1, 'year').subtract(1, 'day').format('YYYY-MMM-DD')}
                                className="form-control"
                                disableClock
                                format="dd-MM-y"
                            />
                            {/* <div
                                className="form-control"
                                readOnly
                            >
                                {moment(values?.effective_date).add(365, 'days').format('YYYY-MMM-DD')}
                            </div> */}
                        </div>
                        <div className="form-group col-md-3">
                            <label>Third-Party Expiry Date</label>
                            <FormikDateTimePicker
                                name="third_party_exp_date"
                                value={values?.third_party_exp_date || ''}
                                className="form-control"
                                disableClock
                                format="dd-MM-y"
                            />
                        </div>
                        {/* <div className="form-row">
                            <div className="form-group col">
                                <label className="col-md-12">Select Policy Type</label>
                                <FormikSelect
                                    items={POLICY_TYPES_LIST}
                                    name="policyType"
                                    className="form-control"
                                />
                            </div>
                        </div> */}

                    </div>
                </div>
            </div>
        </div>
    );
}

Render.propTypes = {
    values: PropTypes.shape({
        cn_date: PropTypes.string,
        self_cn_number: PropTypes.string,
        effective_date: PropTypes.string,
        third_party_exp_date: PropTypes.string,
    }).isRequired,
};

let setSubmitting = () => { };

function VehicleInsuranceCoverNoteForm() {
    const dispatch = useDispatch();
    const { currentRecord, populatedCurrentRecord, upsertReqStatus } = useSelector((state) => state.CaseReducer, shallowEqual);

    const approvedQuotation = currentRecord.quotations.find((quotation) => quotation.isApproved);

    // if current record changed or request status changed the enable submit
    usePrevious(
        {
            currentRecord,
            upsertReqStatus,
        },
        (prev) => {
            if (
                prev.currentRecord !== currentRecord
                || (upsertReqStatus
                    && prev.upsertReqStatus !== upsertReqStatus
                    && upsertReqStatus !== REQUEST_STATUS.PENDING)
            ) {
                setSubmitting(false);
            }
        },
    );

    const onSubmit = (values, formikUtils) => {

       
        ({ setSubmitting } = formikUtils);
        const newRecord = cloneDeep(currentRecord);

        const {
            vehicleIdvValue,
            ratePercentage,
            rateValue,
            loadingDiscountPercentage,
            loadingDiscountValue,
            nonElectAccIdVPercentage,
            nonElectAccIdvValue,
            nonElectAccIdvCharges,
            cndIdvPercentage,
            cndIdvValue,
            cndIdvCharges,
            electIdvPercentage,
            electIdvValue,
            electIdvCharges,
            odPremiumValue,
            vexValue,
            insuranceValueAfterVex,
            ncbPercentage,
            totalPolicyPremium,
            odDiscountPercentage,
            discountPassToCustomer,
            odPremium,
            ncbValue,
            insuranceValueAfterNcb,
            zeroDepreciationPercentage,
            zeroDepreciationValue,
            consumablePercentage,
            consumableValue,
            enginePercentage,
            engineValue,
            returnToInvoicePercentage,
            returnToInvoiceValue,
            goldPlanValue,
            addonOdPremiumValue,
            insuranceValueAfterAddonOd,
            addonDiscountValue,
            newOdPremiumValue,
            thirdPartyValue,
            ownerValue,
            paidDriverValue,
            passengerValue,
            cngThirdPartyValue,
            empLiabValue,
            homeSecureValue,
            comprehensiveValue,
            gstTaxPercentage,
            gstTaxValue,
            insuranceValueWithGst,
            cn_date,
            cn_number,
            losNo,
            InsUAgentCode,
            effective_date,
            third_party_exp_date,
            policyType,
        } = values;
        
        includeStamp(newRecord);
        includeStamp(values);

        newRecord.coverNotes = {
            ...newRecord.coverNotes,

            vehicleIdvValue,
            ratePercentage,
            rateValue,
            loadingDiscountPercentage,
            loadingDiscountValue,
            nonElectAccIdVPercentage,
            nonElectAccIdvValue,
            nonElectAccIdvCharges,
            cndIdvPercentage,
            cndIdvValue,
            cndIdvCharges,
            electIdvPercentage,
            electIdvValue,
            electIdvCharges,
            odPremiumValue,
            vexValue,
            insuranceValueAfterVex,
            ncbPercentage,
            totalPolicyPremium,
            odDiscountPercentage,
            discountPassToCustomer,
            odPremium,
            ncbValue,
            insuranceValueAfterNcb,
            zeroDepreciationPercentage,
            zeroDepreciationValue,
            consumablePercentage,
            consumableValue,
            enginePercentage,
            engineValue,
            returnToInvoicePercentage,
            returnToInvoiceValue,
            goldPlanValue,
            addonOdPremiumValue,
            insuranceValueAfterAddonOd,
            addonDiscountValue,
            newOdPremiumValue,
            thirdPartyValue,
            ownerValue,
            paidDriverValue,
            passengerValue,
            cngThirdPartyValue,
            empLiabValue,
            homeSecureValue,
            comprehensiveValue,
            gstTaxPercentage,
            gstTaxValue,
            insuranceValueWithGst,
            cn_date,
            cn_number,
            losNo,
            InsUAgentCode,
            effective_date,
            third_party_exp_date,
            policyType,
        };

       

        if (!newRecord.coverNotes.self_cn_number) {
            newRecord.coverNotes.self_cn_number = `${newRecord.caseCode}-${newRecord.coverNotes.cn_number}`;
        }

        dispatch(caseUpsertAction(newRecord));
    };

    // if (!approvedQuotation) {
    //     return (
    //         <div
    //             className="alert alert-success"
    //             role="alert"
    //         >
    //             There are no approved quotation for this case to add cover note.
    //         </div>
    //     );
    // }

    const coverNoteData = currentRecord?.coverNotes?.cn_number ? currentRecord.coverNotes : approvedQuotation;

    return (
        <Formik
            onSubmit={onSubmit}
            initialValues={{
                ...VehicleCoverNoteDefaultProps,
                ...coverNoteData,
            }}
            validationSchema={VehicleCoverNoteDefaultSchema}
        >
            {(formikProps) => (
                <Form>
                    <Render
                        {...formikProps}
                    />
                    <VehicleInsuranceQuotationComponent
                        caseType={populatedCurrentRecord.caseType}
                        vehicleInsuranceInterestRate={populatedCurrentRecord?.catalogueId?.meta?.vehicleInsuranceInterestRate}
                        thirdPartyValue={populatedCurrentRecord?.catalogueId?.meta?.thirdPartyValue}
                        ownerValue={populatedCurrentRecord?.catalogueId?.meta?.ownerValue}
                        paidDriverValue={populatedCurrentRecord?.catalogueId?.meta?.paidDriverValue}
                        passengerValue={populatedCurrentRecord?.catalogueId?.meta?.passengerValue}
                        cngThirdPartyValue={populatedCurrentRecord?.catalogueId?.meta?.cngThirdPartyValue}
                        // disableSubmit={currentRecord.stage === STAGE_TYPES.COMPLETED || currentRecord.stage === STAGE_TYPES.CANCELED}
                        disableSubmit={false}
                        disableSubmitMessage={`Not updates are allowed on this case. This case is ${currentRecord.stage}.`}
                        submitButtonText="Update"
                        permissionScope="flow.case_manager.vehicle_insurance_cover_notes.submit"
                        {...formikProps}
                    />
                </Form>
            )}
        </Formik>
    );
}

export default VehicleInsuranceCoverNoteForm;
